export default __webpack_public_path__ + "static/media/single-left-border-left.810e17f4.svg";